import { axios } from "../lib/axios";

export const getAllSources = async function () {
  try {
    const response = await axios.get("settings/getallsources");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getSource = async function (sourceId) {
  try {
    const response = await axios.get("settings/getsource", {
      header: { "Content-Type": "application/json" },
      params: { sourceId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addSource = async function (model) {
  try {
    const response = await axios.post("settings/addsource", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateSource = async function (model) {
  try {
    const response = await axios.post("settings/updatesource", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteSource = async function (model) {
  try {
    const response = await axios.delete("settings/deletesource", {
      data: model,
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
